import React from 'react'
import { Redirect } from "react-router-dom";

const EpisodeRedirect = (props) => {
    
    const episodeID = props.episode;
	var lang = props.lang;
    var newPath = (lang === "en") ? "/search?key=" : "/rechercher?key=";
        
    if(!episodeID || !lang) {
        return null;
    } else {
        return <Redirect push to={newPath + episodeID} />;
    }
     
}

export default EpisodeRedirect;
